// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_o8-0";